// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"847":"dec2d2ac","926":"795bd564"}[chunkId] + ".chunk.css";
};